import React, {useEffect, useState} from 'react';
import {Select} from 'antd';
import {connect} from 'react-redux';
import {withRouter, RouteComponentProps} from 'react-router-dom';

import {fetchRegionList} from '../../actions/dataReview';

interface IRegionComp extends RouteComponentProps {
    provinceData: string | null;
    cityData: string | null;
    areaData: string | null;
    townData: string | null;
    onChange: (value: any, type: string) => void;
    fetchRegionList: (params?: any) => Promise<any>;
    onClear: () => void;
}
const RegionComp: React.FC<IRegionComp> = (props: IRegionComp) => {
    const {provinceData, cityData, areaData, townData, onChange, onClear} = props;
    const [provinceList, setProvinceList] = useState<any>([]);
    const [cityList, setCityList] = useState<any>([]);

    const [areaList, setAreaList] = useState<any>([]);
    const [townList, setTownList] = useState<any>([]);

    useEffect(() => {
        getProvinceList();
    }, []);
    useEffect(() => {
        getCityList();
    }, [provinceData, provinceList]);

    useEffect(() => {
        getAreaList();
    }, [cityData, cityList]);

    useEffect(() => {
        getTownList();
    }, [areaData, areaList]);

    const getProvinceList = async () => {
        const data = await props.fetchRegionList();
        if (data?.code === 200) {
            setProvinceList(data.data.province);
        }
    };

    const getCityList = async () => {
        const provinceArr = provinceList.filter(item => item.name_short === provinceData);
        if (provinceArr.length === 1) {
            const param = {
                province_code: provinceArr[0].code
            };
            const data = await props.fetchRegionList(param);
            if (data?.code === 200) {
                setCityList(data.data.city);
            }
        }
    };
    const getAreaList = async () => {
        const cityArr = cityList.filter(item => item.name_short === cityData);
        if (cityArr.length === 1) {
            const param = {
                city_code: cityArr[0].code
            };
            const data = await props.fetchRegionList(param);
            if (data?.code === 200) {
                setAreaList(data.data.district);
            }
        }
    };
    const getTownList = async () => {
        const areaArr = areaList.filter(item => item.name_short === areaData);
        if (areaArr.length === 1) {
            const param = {
                district_code: areaArr[0].code
            };
            const data = await props.fetchRegionList(param);
            if (data?.code === 200) {
                setTownList(data.data.town);
            }
        }
    };
    return (<div>
        <Select
            value={provinceData}
            onChange={(e) => onChange(e, 'province')}
            placeholder="请选择省"
            style={{width: 130}}
            options={provinceList.map(
                provinceItem => ({label: provinceItem.name_short, value: provinceItem.name_short})
            )}
        >
        </Select>
        <Select
            value={cityData}
            onChange={(e) => onChange(e, 'city')}
            placeholder="请选择市"
            style={{width: 130}}
            options={cityList.map(
                cityItem => ({label: cityItem.name_short, value: cityItem.name_short})
            )}
        >
        </Select>
        <Select
            value={areaData}
            onChange={(e) => onChange(e, 'area')}
            placeholder="请选择区"
            style={{width: 130}}
            options={areaList.map(
                areaItem => ({label: areaItem.name_short, value: areaItem.name_short})
            )}
        >
        </Select>
        <Select
            value={townData}
            onChange={(e) => onChange(e, 'town')}
            placeholder="请选择乡镇"
            style={{width: 130}}
            options={townList.map(
                townItem => ({label: townItem.name, value: townItem.name})
            )}
        >
        </Select>
        <span onClick={onClear} className="clear-btn">清除</span>
    </div>);
};
function mapStateToProps(state) {
    return {
        appealData: state.appealReducer
    };
}
function mapDispatchToProps(dispatch) {
    return {
        fetchRegionList: (param) => fetchRegionList(dispatch, param),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RegionComp));
